import { useEffect, useState } from 'react';
import envConfig from '../../../application/configurations/envConfig';
import { store } from '../../../application/store';
import { checkIntranetContext, getHeaderFooterConfig, UtilityService } from '../../../infrastructure/services/utils';
import { AppUtilityService } from '../../containers/app/appUtils';

/**
 * Component for showing application header.
 *
 * @component
 */

// Function to create cart component as intrinsic element
/* declare global {
  namespace JSX {
    interface IntrinsicElements {
      'wc-cart': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
    }
  }
} */
const Header = () => {
  const [html, setHtml] = useState('')
  const [searchType, setSearchType] = useState<any>(null)
  const [referrer, setReferrer] = useState<any>(null)
  const userDetails = store.getState().general


  useEffect(() => {
    // Get redirection page name from 'c' query param
    const searchParams = checkIntranetContext()
    setSearchType(searchParams);

    // Get previous URL
    const previousUrl = document.referrer
    //get the url in this format 'intranet.ey.com' by removing https:// and / from the url

    const url = previousUrl.replace('https://', '').replace('/', '');
    setReferrer(url);
  }, [searchType, referrer])


  useEffect(() => {
    if (userDetails.token) {
      let userEmailIdPath = '';
      if (userDetails.account.username) {
        let encodedEmail = encodeURIComponent(
          btoa(userDetails.account.username)
        );
        userEmailIdPath = '.' + encodedEmail + '.html';
      }
      const headerUrl = getHeaderFooterConfig('header');
      if (!headerUrl) return;
      fetch(headerUrl + userEmailIdPath,
        {
          credentials: 'include',
          headers: {
            'Authorization': 'Bearer ' + userDetails.token
          }
        })
        .then(async function (payload) {
          if (payload.status === 200) {
            let res = await payload.text();
            if (res != "") {
              await UtilityService.cssLoad(res);
              setHtml(res);
              UtilityService.scriptLoad(res);
            }
          }
        })
    }
  }, [userDetails.token])

  useEffect(() => {
    // Favicon icon change as per light and dark theme with focus as well as with mounting
    window.addEventListener('focus', AppUtilityService.favIcoLoad, false);
    AppUtilityService.favIcoLoad();

    // Remove the event listener when component unmounts
    return () => window.removeEventListener('focus', AppUtilityService.favIcoLoad);
  }, [])

  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: html }} />
      {/* <wc-cart></wc-cart> */} {/* Export Cart web component TAG */}
    </div>
  );
}

export { Header };
